import { Response, SuperAgentRequest } from 'superagent'

import { SESSION_STATE_MIRROR_HEADER, SessionStateStore } from '@/services/session/session-state-store'

/**
 * 応答にX-Session-Stateミラーヘッダがあればstate storeへ取り込むリスナーを付ける。
 *
 * superagentの'response'イベントはリクエストのpromise解決より先に発火するため、
 * API呼び出しのawait完了時点でstoreは応答の状態を反映済みになる。
 * ミラーを載せるかどうかはserver側の責務のため、全リクエストへ無条件に付けてよい。
 */
export const attachSessionStateMirrorListener = (
  request: SuperAgentRequest,
  store: SessionStateStore = SessionStateStore.getInstance()
): SuperAgentRequest => {
  request.on('response', (response: Response) => {
    const headers = response.headers || {}
    // superagentはレスポンスヘッダ名を小文字で公開する
    const headerValue = headers[SESSION_STATE_MIRROR_HEADER.toLowerCase()]
    if (typeof headerValue === 'string' && headerValue !== '') {
      store.updateFromMirrorHeader(headerValue)
    }
  })

  return request
}
